module.exports = __webpack_public_path__ + "img/4.319d59fb.png";